module.exports = __webpack_public_path__ + "img/lamina.749b32f6.png";